var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.11719V12.2225",
    stroke: "#0F172A",
    strokeWidth: 1.33562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0554 9.16992H5.94434",
    stroke: "#0F172A",
    strokeWidth: 1.33562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9046 0.844482H5.09508C2.37285 0.844482 0.666504 2.77122 0.666504 5.49878V12.8569C0.666504 15.5844 2.36492 17.5111 5.09508 17.5111H12.9046C15.6348 17.5111 17.3332 15.5844 17.3332 12.8569V5.49878C17.3332 2.77122 15.6348 0.844482 12.9046 0.844482Z",
    stroke: "#0F172A",
    strokeWidth: 1.33562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.ecaf52aa6de60746746dbd8c547bbc40.svg";
export { ForwardRef as ReactComponent };